import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";

// Authentication
import { setUser } from "./features/authSlice.ts";
import { store } from "./app/store.ts";
import { useAppDispatch } from "./app/hooks.ts";

//toastify
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

//pages
import Auth from "./pages/Auth/auth.tsx";
import Dashboard from "./pages/Dashboard/Dashboard.tsx";
import CreateTicket from "./pages/CreateTicket/CreateTicket.tsx";
import TicketTrafficManagement from "./pages/TicketTrafficManagement/TicketTrafficManagement.tsx";
import Tickets from "./pages/Tickets/Tickets.tsx";
import TicketPage from "./pages/TicketPage/TicketPage.tsx";
import Users from "./pages/Users/Users.tsx";

const UserInitializer: React.FC = () => {
  const dispatch = useAppDispatch();
  const user = JSON.parse(localStorage.getItem("user") || "{}"); // error if no user in local storage

  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      dispatch(setUser(user));
    }
  }, [dispatch, user]);

  return null;
};

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <BrowserRouter>
          <UserInitializer />
          <ToastContainer />
          <Routes>
            <Route path="/" element={<Navigate to="/auth" replace />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create-ticket" element={<CreateTicket />} />
            <Route
              path="/tickettrafficmanagement"
              element={<TicketTrafficManagement />}
            />
            <Route path="/Tickets" element={<Tickets />} />
            <Route path="/ticket/:ticket_id" element={<TicketPage />} />
            <Route path="/Users" element={<Users />} />
          </Routes>
        </BrowserRouter>
      </div>
    </Provider>
  );
}

export default App;
